import { useProductStore } from '../../../contexts/product'
import { useProductModal } from '../../../contexts/productModal'
import { useTracking } from '../../../contexts/tracking'
import type { ProductInfoProduct, Variant } from '../../../types'
import { useCanNavigateInModal } from '../../../utils/useCanNavigateInModal'

type Props = {
  products: ProductInfoProduct[]
  listName: string
  listPosition: string
  component: 'tabbed' | 'carousel'
}

export const useMoreLikeThisProductSelect = ({
  products,
  listName,
  listPosition,
  component,
}: Props) => {
  const { showProduct } = useProductModal()
  const [, dispatcher] = useProductStore()
  const canNavigateInModal = useCanNavigateInModal()
  const tracking = useTracking()
  const listIndex = parseInt(listPosition.split('/')[0], 10)
  const listTotal = parseInt(listPosition.split('/')[1], 10)

  return (index: number) => {
    const product = products[index]

    if (canNavigateInModal) {
      showProduct(product)
    } else {
      dispatcher.setProduct(product)
    }

    tracking.selectProduct({
      product,
      list: {
        name: listName,
        index: listIndex,
        totalNumberOfLists: listTotal,
        length: products.length,
      },
      variant: product.masterVariant as Variant,
      index,
      component,
    })
  }
}
